// The backend buckets each row's onboarding status into one of these labels so the grid can
// sort/filter on it server-side; the FE renders the returned label.
export const ONBOARDING_NO_PROGRAM = "No compliance program assigned";
export const ONBOARDING_ACTION_REQUIRED = "Action required";
export const ONBOARDING_IN_PROGRESS = "In progress";
export const ONBOARDING_PENDING_REVIEW = "Pending review";
export const ONBOARDING_CLOSED = "Closed";

// Every label the backend can return, in display order — the column's set-filter values.
export const ONBOARDING_STATUS_FILTER_VALUES = [
  ONBOARDING_NO_PROGRAM,
  ONBOARDING_ACTION_REQUIRED,
  ONBOARDING_IN_PROGRESS,
  ONBOARDING_PENDING_REVIEW,
  ONBOARDING_CLOSED,
] as const;

export type OnboardingState =
  { kind: "no-program" } | { kind: "action-required" } | { kind: "status"; status: string };

/** Maps the backend's bucketed label to how the cell renders (no-program / action-required / status). */
export const resolveOnboardingState = (
  onboardingStatus: string | null | undefined,
): OnboardingState => {
  if (!onboardingStatus || onboardingStatus === ONBOARDING_NO_PROGRAM) {
    return { kind: "no-program" };
  }
  if (onboardingStatus === ONBOARDING_ACTION_REQUIRED) {
    return { kind: "action-required" };
  }
  return { kind: "status", status: onboardingStatus };
};
